import { ImportConfiguration } from "../../types/importConfiguration";
import { API_PATHS } from "../API_PATHS";
import { request } from "../utils";

export const getTemplate = (param?: string) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.FILE.DOWNLOAD_TEMPLATE(param)}`,
    responseType: "blob",
  });
};

export const uploadFile = (data: any) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.FILE.UPLOAD}`,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getSourceEntities = (data: any, headers: any) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_SOURCE_ENTITIES()}`,
    data,
    headers
  });
};

export const getDataverseInstances = (headers: any) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.DATAVERSE.GET_DATAVERSE_INSTANCES()}`,
    headers
  });
};

export const getImportConfigurations = (
  organizationId: number,
  tenantId: number,
  adapterIdentifier: string
) => {
  return request({
    method: "GET",
    // eslint-disable-next-line max-len
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_IMPORT_CONFIGURATIONS(organizationId, tenantId, adapterIdentifier)}`,
  });
};

export const getDefaultImportConfiguration = (
  organizationId: number,
  tenantId: number,
  adapterIdentifier: string,
  destinationIdentifier: string
) => {
  return request({
    method: "GET",
    // eslint-disable-next-line max-len
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_DEFAULT_IMPORT_CONFIGURATION(organizationId, tenantId, adapterIdentifier, destinationIdentifier)}`,
  });
};

export const getDestinationMetadata = (
) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_DESTINATION_METADATA()}`,
  });
};

export const getSourceProperties = (
  OrganizationId: number,
  TenantId: number,
  AdapterIdentifier: string,
  SourceIdentifier: string,
  ImportConfigurationArguments: Record<string, string>,
  OperationIdentifier: string,
  headers?: any
) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_SOURCE_PROPERTIES()}`,
    data: {
      OrganizationId,
      TenantId,
      SourceIdentifier,
      AdapterIdentifier,
      ImportConfigurationArguments,
      OperationIdentifier
    },
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
  });
};

export const saveImportConfiguration = (organizationId: number,
  importConfiguration: ImportConfiguration) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.SAVE_IMPORT_CONFIGURATION()}`,
    data: {
      organizationId,
      importConfiguration
    },
    headers: {
      "Content-Type": "application/json"
    },
  });
};

export const deleteImportConfiguration = (organizationId: number, tenantId: number,
  id: number) => {
  const queryString = new URLSearchParams({
    OrganizationId: String(organizationId),
    TenantId: String(tenantId),
    id: String(id)
  });

  return request({
    method: "DELETE",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.DELETE_IMPORT_CONFIGURATION()}?${queryString.toString()}`,
    data: {
      OrganizationId: organizationId,
      TenantId: tenantId,
      id
    },
    headers: {
      "Content-Type": "application/json"
    },
  });
};

export const getPreview = (
  OrganizationId: number,
  TenantId: number,
  AdapterIdentifier: string,
  SourceIdentifier: string,
  DestinationIdentifier: string,
  OperationIdentifier: string,
  ImportConfigurationArguments: Record<string, string>,
  DestinationSourceFieldMappings: Record<string, string>,
  headers?: Record<string, string>
) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_PREVIEW()}`,
    data: {
      OrganizationId,
      TenantId,
      SourceIdentifier,
      DestinationIdentifier,
      AdapterIdentifier,
      OperationIdentifier,
      ImportConfigurationArguments,
      DestinationSourceFieldMappings
    },
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
  });
};

export const getPreviewDemo = () => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.GET_PREVIEW_DEMO()}`,
    headers: {
      "Content-Type": "application/json"
    },
  });
};

export const saveData = (
  OrganizationId: number,
  TenantId: number,
  AdapterIdentifier: string,
  SourceIdentifier: string,
  DestinationIdentifier: string,
  OperationIdentifier: string,
  ImportConfigurationArguments: Record<string, string>
) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.SAVE_DATA()}`,
    data: {
      OrganizationId,
      TenantId,
      SourceIdentifier,
      DestinationIdentifier,
      AdapterIdentifier,
      OperationIdentifier,
      ImportConfigurationArguments
    },
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const saveDataDemo = (
  organizationId: number,
  tenantId: number
) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.SAVE_DATA_DEMO()}`,
    data: {
      organizationId,
      tenantId
    },
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const importMSPlannerTables = (data: any, headers: any) => {
  return request({
    method: "POST",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.MSPLANNER_TABLES()}`,
    data,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  });
};

// export const importNotifications = (operationIdentifier: string, headers: any) => {
//   return new EventSource(`${API_PATHS.BASE_URLS.API_URL}${API_PATHS.IMPORT.NOTIFICATIONS()}?operationIdentifier=${operationIdentifier}`, {
//     headers: {
//       "Content-Type": "application/json",
//       ...headers
//     },
//     responseType: 'stream'
//   });
// }